import { Cfdi } from "./Cfdi";
import { Customer } from "./Customer";

export interface Payment {
    id: string;
    tenant_id: string;
    customer_id: string;
    user_id: string;
    payment_cfdis: PaymentCfdi[];
    total: number;
    currency: string;
    account: string;
    status: "NEW" | "VALIDATING" | "COMPLETED" | "EXPIRED" | "INVALID";
    expires_at: Date;
    created_at: Date;
    customer?: Customer;
    transaction?: PaymentTransaction;
}

export interface PaymentCfdi {
    cfdi_id: string;
    currency: string;
    payment: number;
    amount: number;
    balance_after: number;
    exchange_rate?: number;
    cfdi?: Cfdi;
}

export interface PaymentTransaction {
    date: Date;
    form: string;
    reference?: string;
    check_number?: string;
    file?: string;
}

export interface Payments {
    items: Payment[];
    total: number;
}

export interface PaymentsQueryParams {
    search: string;
    status?: string;
    archive: boolean;
}

export interface SchedulePaymentRequest {
    payment_cfdis: PaymentCfdiRequest[];
    total: number;
    currency?: string;
    date?: Date;
}

export interface PaymentCfdiRequest {
    cfdi_id: string;
    payment: number;
    amount: number;
    balance: number;
    exchange_rate?: number;
    partial: boolean;
    serie_folio: string;
    currency: string;
    uuid?: string;
    date: Date;
}

export interface PaymentExchangeRateResponse {
    currency: string;
    value: number;
}

export interface PaymentMetadataResponse {
    dollar: number;
    euro: number;
}

export interface RegisterTransactionRequest {
    date?: Date;
    form: string;
    check_number?: string;
    reference?: string;
    file: string;
}

export interface RegisterPaymentRequest {
    date: Date;
    currency: string;
    amount: number;
    form: string;
    check_number?: string;
    reference?: string;
    file: string;
}

export interface PaymentConciliateRequest {
    approved: boolean;
}

export const PAYMENT_FORM = ["TRANSFER", "CHECK"];

export const PAYMENT_STATUS_TENANT = ["VALIDATING", "COMPLETED", "INVALID"];

export const PAYMENT_STATUS_CUSTOMER = ["NEW", "EXPIRED", "VALIDATING", "COMPLETED", "INVALID"];

export const PAYMENT_STATUS_CUSTOMER_PENDING = ["NEW", "EXPIRED", "VALIDATING"];